import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class LinkPlayerApiModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "player", null);
    _defineProperty(this, "searchQuery", '');
    _defineProperty(this, "searching", false);
    _defineProperty(this, "linking", false);
    _defineProperty(this, "searchResults", []);
    _defineProperty(this, "apiRequests", null);
    _defineProperty(this, "searchType", 'player');
    _defineProperty(this, "filterBy", 'league');
    _defineProperty(this, "searchLeagueId", '140');
    _defineProperty(this, "searchTeamId", '');
    _defineProperty(this, "teams", []);
    _defineProperty(this, "loadingTeams", true);
    _defineProperty(this, "leagues", [{
      id: '140',
      name: 'Primera División (España)'
    }, {
      id: '141',
      name: 'Segunda División (España)'
    }, {
      id: '435',
      name: 'Primera RFEF - Grupo 1'
    }, {
      id: '436',
      name: 'Primera RFEF - Grupo 2'
    }, {
      id: '437',
      name: 'Segunda RFEF - Grupo 1'
    }, {
      id: '438',
      name: 'Segunda RFEF - Grupo 2'
    }, {
      id: '439',
      name: 'Segunda RFEF - Grupo 3'
    }, {
      id: '440',
      name: 'Segunda RFEF - Grupo 4'
    }, {
      id: '441',
      name: 'Segunda RFEF - Grupo 5'
    }, {
      id: '143',
      name: 'Copa del Rey (España)'
    }, {
      id: '2',
      name: 'Champions League'
    }, {
      id: '3',
      name: 'Europa League'
    }, {
      id: '39',
      name: 'Premier League (Inglaterra)'
    }, {
      id: '135',
      name: 'Serie A (Italia)'
    }, {
      id: '61',
      name: 'Ligue 1 (Francia)'
    }, {
      id: '78',
      name: 'Bundesliga (Alemania)'
    }]);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.player = this.attrs.player;
    this.searchQuery = this.player ? this.player.name() : '';
    this.searchType = this.player && this.player.attribute('entityType') === 'coach' ? 'coach' : 'player';
    this.loadTeams();
  }
  className() {
    return 'LinkPlayerApiModal Modal--medium';
  }
  title() {
    return "Vincular \"".concat(this.player ? this.player.name() : 'Jugador', "\" con la API Externa");
  }
  loadTeams() {
    this.loadingTeams = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/teams'
    }).then(response => {
      this.teams = app.store.pushPayload(response);
      this.loadingTeams = false;
      if (this.teams.length > 0) {
        this.searchTeamId = String(this.teams[0].id());
      }
      m.redraw();
      // Si el nombre tiene al menos 3 caracteres, lanzar la búsqueda inicial automáticamente
      if (this.searchQuery.trim().length >= 3) {
        this.search();
      }
    }).catch(() => {
      this.loadingTeams = false;
      m.redraw();
    });
  }
  search(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.searchQuery.trim().length < 3) {
      alert(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.search_min_chars'));
      return;
    }
    this.searching = true;
    this.searchResults = [];
    this.apiRequests = null;
    m.redraw();
    const params = {
      search: this.searchQuery.trim(),
      type: this.searchType
    };
    if (this.filterBy === 'team') {
      if (this.searchTeamId) {
        params.team = this.searchTeamId;
      }
    } else {
      params.league = this.searchLeagueId;
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/search-players',
      params
    }).then(response => {
      this.searchResults = response.results || [];
      this.apiRequests = response.requests || null;
      this.searching = false;
      m.redraw();
    }).catch(err => {
      this.searching = false;
      console.error(err);
      m.redraw();
    });
  }
  linkPlayer(apiPlayer) {
    // En lugar de aplicar a ciegas, abrir el comparador interactivo
    this.hide();
    app.modal.show(SyncPlayerModal, {
      player: this.player,
      apiPlayerData: {
        apiId: apiPlayer.id,
        name: apiPlayer.name,
        photoUrl: apiPlayer.photoUrl,
        number: apiPlayer.number,
        position: apiPlayer.position,
        birthDate: apiPlayer.birthDate,
        birthPlace: apiPlayer.birthPlace,
        height: apiPlayer.height,
        weight: apiPlayer.weight,
        entityType: apiPlayer.entityType || 'player'
      },
      isLinkingNew: true,
      onSync: res => {
        if (this.attrs.onLink) {
          this.attrs.onLink(res);
        }
      }
    });
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      style: "background: rgba(59, 130, 246, 0.08); border: 1px solid rgba(59, 130, 246, 0.2); border-radius: 12px; padding: 12px 16px; margin-bottom: 20px; font-size: 0.9em; color: var(--heading-color); display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "fas fa-link",
      style: "color: #60a5fa; font-size: 1.4rem;"
    }), m("div", null, "Est\xE1s vinculando a ", m("strong", null, this.player ? this.player.name() : ''), " (ID Interno: ", m("code", null, "#", this.player ? this.player.id() : ''), "). Su historial de votos, convocatorias y alineaciones se mantendr\xE1 100% intacto.")), m("div", {
      style: "margin-bottom: 20px; display: flex; flex-direction: column; gap: 10px;"
    }, m("div", {
      style: "display: flex; gap: 8px; align-items: center; width: 100%;"
    }, m("input", {
      className: "FormControl",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.link_player_modal.search_placeholder')),
      value: this.searchQuery,
      oninput: e => this.searchQuery = e.target.value,
      onkeydown: e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.search();
        }
      },
      style: "flex: 1; min-width: 0; border-radius: 8px; height: 48px; min-height: 48px; padding: 12px 14px; font-size: 15px; line-height: normal; box-sizing: border-box;"
    }), m(Button, {
      className: "Button Button--primary",
      onclick: this.search.bind(this),
      loading: this.searching,
      style: "border-radius: 8px; height: 48px; min-height: 48px; padding: 0 18px; font-weight: bold; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; flex-shrink: 0;"
    }, m("i", {
      className: "fas fa-search"
    }), m("span", null, "Buscar"))), m("div", {
      style: "display: grid; grid-template-columns: 1fr 1fr; gap: 8px; width: 100%;"
    }, m("select", {
      className: "FormControl",
      value: this.searchType,
      onchange: e => this.searchType = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: "player"
    }, "Jugadores"), m("option", {
      value: "coach"
    }, "Entrenadores")), m("select", {
      className: "FormControl",
      value: this.filterBy,
      onchange: e => this.filterBy = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, m("option", {
      value: "league"
    }, "Por Divisi\xF3n"), m("option", {
      value: "team"
    }, "Por Equipo"))), m("div", {
      style: "width: 100%;"
    }, this.filterBy === 'league' ? m("select", {
      className: "FormControl",
      value: this.searchLeagueId,
      onchange: e => this.searchLeagueId = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, this.leagues.map(l => m("option", {
      value: l.id
    }, l.name))) : m("select", {
      className: "FormControl",
      value: this.searchTeamId,
      onchange: e => this.searchTeamId = e.target.value,
      style: "width: 100%; border-radius: 8px; height: 48px; min-height: 48px; padding: 0 35px 0 14px; font-size: 14px; line-height: 46px; box-sizing: border-box;"
    }, this.teams.map(t => m("option", {
      value: t.id()
    }, t.name()))))), this.apiRequests && m("div", {
      style: "background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 8px; padding: 8px 14px; margin-bottom: 15px; font-size: 0.85em; display: flex; align-items: center; justify-content: space-between; color: var(--muted-color);"
    }, m("div", null, "L\xEDmite diario: ", m("strong", null, this.apiRequests.limit), ". Consultas hoy: ", m("strong", null, this.apiRequests.current), "."), m("span", {
      style: "background: rgba(255,255,255,0.08); padding: 2px 6px; border-radius: 4px; font-weight: bold; color: var(--heading-color);"
    }, "Quedan: ", this.apiRequests.remaining)), this.searching ? m("div", {
      style: "text-align: center; padding: 30px 0;"
    }, m(LoadingIndicator, null)) : m("div", {
      className: "Search-results",
      style: "max-height: 350px; overflow-y: auto; border: 1px solid rgba(255,255,255,0.06); border-radius: 8px; background: rgba(255,255,255,0.01);"
    }, this.searchResults.map(apiPlayer => m("div", {
      key: apiPlayer.id,
      className: "Search-result-item",
      style: "display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; border-bottom: 1px solid rgba(255,255,255,0.05);"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 15px;"
    }, apiPlayer.photoUrl ? m("img", {
      src: apiPlayer.photoUrl,
      alt: apiPlayer.name,
      style: "height: 44px; width: 44px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(255,255,255,0.1);"
    }) : m("div", {
      style: "height: 44px; width: 44px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center;"
    }, m("i", {
      className: "fas fa-user",
      style: "color: var(--muted-color);"
    })), m("div", {
      style: "display: flex; flex-direction: column;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 8px;"
    }, m("span", {
      style: "font-weight: bold; color: var(--heading-color);"
    }, apiPlayer.name), apiPlayer.entityType === 'coach' && m("span", {
      className: "Player-Role-Badge coach",
      style: "background: rgba(234, 179, 8, 0.2); color: #facc15; border: 1px solid rgba(234, 179, 8, 0.4); border-radius: 4px; padding: 1px 6px; font-size: 0.75em; font-weight: bold;"
    }, "Entrenador")), m("span", {
      style: "font-size: 0.85em; color: var(--muted-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.add_player_modal.provider_id'), ": ", m("code", null, "#", apiPlayer.id), " ", apiPlayer.teamName ? "\u2022 ".concat(apiPlayer.teamName) : ''))), m(Button, {
      className: "Button Button--primary Button--small",
      loading: this.linking,
      onclick: () => this.linkPlayer(apiPlayer),
      style: "border-radius: 6px; font-weight: bold; display: inline-flex; align-items: center; gap: 6px;"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_mgmt.link_player_modal.select_and_review_btn')))), this.searchResults.length === 0 && !this.searching && m("div", {
      style: "text-align: center; padding: 25px; color: var(--muted-color); font-style: italic;"
    }, "No se han encontrado resultados en el proveedor para \"", this.searchQuery, "\".")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/LinkPlayerApiModal', LinkPlayerApiModal);